import { styled } from "@mui/material";
import { dateCalendarName } from "../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "width"]);
const Root = styled("div", {
  name: dateCalendarName,
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ width }) => ({
  width
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
